<template>
  <v-dialog v-model="dialog" hide-overlay persistent width="300">
    <v-card color="secondary" dark>
      <v-card-text>
        {{ $t('stand_by') }}
        <v-progress-linear
          indeterminate
          color="white"
          class="mb-0"
        ></v-progress-linear>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialog: false
    }
  },
  methods: {
    show(val) {
      this.dialog = val
    }
  }
}
</script>
